import { IDropdownOption } from '@fluentui/react';

import { Grouping } from '../../../telemetry/gen/ai/h2o/cloud/telemetry_read_api/h2ogpte/v1/h2ogpte_pb';

export const h2ogpteGroupByOptions: IDropdownOption[] = [
  {
    key: Grouping.WORKSPACE,
    text: 'Workspace',
  },
  {
    key: Grouping.USER,
    text: 'User',
  },
  {
    key: Grouping.MODEL,
    text: 'Model',
  },
];
